module.exports = __webpack_public_path__ + "files/e1ac7da98725348ca0ad5bd4ab06c9c4.svg";